import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { routePath } from '@brightside-web/desktop/data-access/core-services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActionCardConfigInterface } from 'libs/brightside-ui/src/lib/action-card/action-card.component';
import { BrightsideUiModule } from 'libs/brightside-ui/src/lib/brightside-ui.module';

@Component({
    selector: 'brightside-web-my-spending-action-card',
    imports: [BrightsideUiModule, TranslateModule],
    templateUrl: './my-spending-action-card.component.html',
    styleUrl: './my-spending-action-card.component.scss'
})
export class MySpendingActionCardComponent implements OnInit {
  data: { route: string | undefined };
  actionCardConfig: ActionCardConfigInterface;

  private _router = inject(Router); 
  private _translateService = inject(TranslateService);

  ngOnInit() {
    this.actionCardConfig = {
      label: this._translateService.instant('TAKE_ACTION'),
      labelSub: this._translateService.instant('MY_SPENDING_PENDING_MINUTES'),
      title: this._translateService.instant('MY_SPENDING_PENDING_TITLE'),
      body: this._translateService.instant('MY_SPENDING_PENDING_DESC'),
      cardStyle: 'small',
      labelIcon: 'icon-actions',
      labelSubRemoveDash: true,
      marginBottom: 'small'
    };
  }

  navigate(): void {
    this._router.navigate([this.data?.route || routePath('my_spending')]);
  }
}
